import { useContext } from 'react';
import AuthContext from 'src/contexts/OdooAuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
